import { Component, OnInit } from '@angular/core';
import { Session } from '../../services/session.service';

@Component({
    selector: 'app-auditor-dashboard',
    template: ` @if (showSearch) {<app-search-page></app-search-page>} `,
    styles: [``],
    standalone: false
})
export class AuditorDashboardPageComponent implements OnInit {
  showSearch = false;

  constructor(private session: Session) {}

  async ngOnInit() {
    await this.session.loadUser();

    if (this.session.user.userType === 'INTERNALAUDITOR') {
      const clients = await this.session.getInternalAuditorClientsList();
      this.showSearch = clients && clients.length > 0;
    } else {
      // For external auditors auditors cant be created before contract effective date
      this.showSearch = true;
    }
  }
}
